/* Global function to toggle a css class on an element */
export const toggleCssClass = function (element, className) {
  if (element.classList.contains(className)) {
    element.classList.remove(className);
    return "remove"; //Return state so a function can be executed if needed
  } else {
    element.classList.add(className);
    return "add"; //Return state so a function can be executed if needed
  }
};

/* Global function to toggle a d-none on an element */
export const toggleDisplay = function ({ isVisible, element }) {
  switch (isVisible) {
    case false:
      element.classList.add("d-none");
      break;
    case true:
      element.classList.remove("d-none");
      break;
    default:
      element.classList.toggle("d-none");
  }
};

/* Global function to toggle a text on an element */
export const toggleText = function (element) {
  const oldText = element.innerText; //Get the current text inside the button and store it
  element.innerText = element.getAttribute("data-text"); //Set the text to the new text
  element.setAttribute("data-text", oldText); //Store the old text in the text attribute so we can use is again.
};
